import {
  ConfigObjectType,
  i18nContainer,
  loginContainer,
  PaginatedResponse,
  StateId,
} from '@wallaby-ui/core';
import * as React from 'react';
import {defineMessages} from 'react-intl';
import {connect, ConnectedProps} from 'react-redux';
import {GridPagination} from 'src/js/containers/grid/grid_slice';
import {SelectedRow} from 'src/js/containers/grid/grid_types';
import {loadStateFromParams} from 'src/js/containers/list/list_thunks';
import {useInitializeGrid} from 'src/js/hooks/useInitializeGrid';
import {RootState} from 'src/js/store';

import {MUIListWrapperBox} from './MUIListWrapperBox';

export const I18N = defineMessages({
  EMPTY_EXPORT: {
    id: 'export.emptyMessage',
    defaultMessage: 'It is not possible to export empty data.',
    description: 'error message on empty export',
  },
});

export interface OwnProps {
  filterAndSearchStateId: StateId;
  gridId: string;
  listStateId: StateId;
  serviceUrls: Record<string, any>;
  config: ConfigObjectType;
  exportDisabled?: boolean;
  helpText?: string;
  defaultPagination?: GridPagination;
  handlePaginationDataChange?: (count?: number) => void;
  onDataLoaded?: (data: PaginatedResponse | undefined) => void;
  showPageSize?: boolean;
  selectedRow?: SelectedRow;
  dataTransformFunction?: (data: any) => any;
  featureName?: string;
}

const mapState = (state: RootState, props: OwnProps) => ({
  currentLocale: state[i18nContainer.I18N_REDUCER_STATE_ID].currentLocale,
  locationState: state[props.listStateId].locationState,
});

const mapDispatch = {
  loadStateFromParamsAC: loadStateFromParams,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const MUIListWrapperContainerComponent: React.FC<Props> = (props) => {
  const {
    config,
    filterAndSearchStateId,
    locationState,
    gridId,
    listStateId,
    serviceUrls,
    defaultPagination,
    handlePaginationDataChange,
    onDataLoaded,
    showPageSize,
    selectedRow,
    dataTransformFunction,
    featureName,
  } = props;

  const {onGridInitialize} = useInitializeGrid({
    listStateId,
    filterAndSearchStateId,
    locationState,
    gridId,
    defaultPagination,
    featureName,
  });

  return (
    <MUIListWrapperBox
      config={config}
      filterAndSearchStateId={filterAndSearchStateId}
      gridId={gridId}
      serviceUrls={serviceUrls}
      onDataLoaded={onDataLoaded}
      onGridInitialize={onGridInitialize}
      handlePaginationDataChange={handlePaginationDataChange}
      showPageSize={showPageSize}
      selectedRow={selectedRow}
      dataTransformFunction={dataTransformFunction}
      featureName={featureName}
    />
  );
};

MUIListWrapperContainerComponent.displayName = 'MUIListWrapperContainer';

export const MUIListWrapperContainer = connector(
  MUIListWrapperContainerComponent
);
